import React from "react"
import ArticleCard from "./ArticleCard"
import { useStaticQuery, graphql } from "gatsby"

const Feeds = ({ articles }) => {

  const articlesValue = articles || [];
  // Calculate the column count based on the number of entries
   const entryCount = articlesValue.length;
   let columnCount = "grid-cols-3"; // Default to 3 columns

   if (entryCount === 1) {
     columnCount = "grid-cols-2";
   } else if (entryCount === 2) {
     columnCount = "grid-cols-2";
   }

    return (
      <div className={`grid md:${columnCount} gap-x-8 gap-y-16 px-4 md:px-8 feed`}>
        {articles && articles.map((article) => (
          <ArticleCard article={article || []} key={`${article.slug}`} />
        ))}
      </div>
    )
  }
export default Feeds
